import { createSlice } from '@reduxjs/toolkit'
import partGroupes from '../../utils/constants/partGroupes'
import _ from 'lodash'
import getSortOrder from '../../utils/sort/getSortOrder'

let initialState = partGroupes.reduce((acc, partGroup) => {
    const type = partGroup.type

    acc[type] = {
        sortBy: '',
        sortOrder: ''
    }

    return acc
}, {})

export { initialState }

export const priceSortField = 'price_src'
export const quantitySortField = 'quantity'
export const deliverySortField = 'delivery'

const setSort = (state, action) => {
    state[action.payload.type].sortOrder = getSortOrder(
        state[action.payload.type].sortBy,
        action.payload.sortBy,
        state[action.payload.type].sortOrder
    )

    state[action.payload.type].sortBy = action.payload.sortBy

    return state
}

export const sortSlice = createSlice({
    name: 'sort',
    initialState,
    reducers: {
        setQuantitySort: (state, action) => {
            state = setSort(state, {
                ...action,
                payload: {
                    ...action.payload,
                    sortBy: quantitySortField
                }
            })
        },
        setDeliverySort: (state, action) => {
            state = setSort(state, {
                ...action,
                payload: {
                    ...action.payload,
                    sortBy: deliverySortField
                }
            })
        },
        setPriceSort: (state, action) => {
            state = setSort(state, {
                ...action,
                payload: {
                    ...action.payload,
                    sortBy: priceSortField
                }
            })
        }
    }
})

export const { setQuantitySort, setDeliverySort, setPriceSort } = sortSlice.actions

const selectSortByType = (state, sortBy) =>
    _.mapValues(state.sort, (sort) => (sort.sortBy === sortBy ? sort.sortOrder : ''))

export const selectQuantitySort = (state) => selectSortByType(state, quantitySortField)
export const selectDeliverySort = (state) => selectSortByType(state, deliverySortField)
export const selectPriceSort = (state) => selectSortByType(state, priceSortField)

export const selectSort = (state) => state.sort

export default sortSlice.reducer
